<template>
  <div class="container">
    <div class="head">
      <div class="title">
        <div class="text">{{subName}}</div>
        <div v-if="Number(assessDetail.deduction)==0" class="no-de">未扣分</div>
        <div v-else class="branch">-{{assessDetail.deduction}}</div>
      </div>
      <div class="tag-box">
        <txtTag
          class="tag"
          :bgColor="'#fff'"
          :border="'#36B374'"
          :txtColor="'#36B374'"
        >{{detailsInfo.areaName}}</txtTag>
        <txtTag
          class="tag"
          :bgColor="'#fff'"
          :border="'#36B374'"
          :txtColor="'#36B374'"
        >{{detailsInfo.areaType==1?'一':'二'}}类地区</txtTag>
        <txtTag
          class="tag"
          :bgColor="'#fff'"
          :border="'#36B374'"
          :txtColor="'#36B374'"
        >{{quarterName}}</txtTag>
      </div>
      <!-- <div class="tip">
        <div class="con"><div class="label">{{detailsInfo.areaName}}</div></div>
        <div class="con"><div class="label">{{detailsInfo.areaType==1?'一':'二'}}类地区</div></div>
      </div>-->
      <!-- <div class="left">
                  <div class="companyAdress line_border_green"><div class="companyAdressItem">{{detailsInfo.areaName}}</div></div>
                  <div class="companyAdress line_border_green"><div class="companyAdressItem">{{detailsInfo.areaType==1?'一':'二'}}类地区</div></div>
      </div>-->
      <div class="date" v-if="assessDetail.deductionTime">{{assessDetail.deductionTime}}</div>
    </div>

    <div class="pg-pd12">
      <!-- 扣分原因 -->
      <template v-if="isShow">
        <causeDeduction :causeContent="deductionReason" causeTitle="扣分原因"></causeDeduction>
      </template>

      <!-- 事故详情 -->
      <!-- dev-1.2.0关闭 -->
      <template v-if="isShow && caseDetail&&pageType!='C'">
        <causeDeduction :causeContent="caseDetail" causeTitle="事故详情"></causeDeduction>
      </template>

      <!-- 扣分详情 -->
      <!-- dev-1.2.0关闭 -->
      <template v-if="isShow && deducDetail&&pageType!='C'">
        <causeDeduction :causeContent="deducDetail" causeTitle="扣分详情"></causeDeduction>
      </template>

      <!-- 涉旅案件公示 -->
      <!-- dev-1.2.0关闭 -->
      <template
        v-if="tripCaseList!=null&&tripCaseList!=''&&tripCaseList!={}&&tripCaseList.length>0&&pageType!='C'"
      >
        <casePublicity :caseList="tripCaseList"></casePublicity>
      </template>

      <!-- 投诉件详情 -->
      <!-- dev-1.2.0关闭 -->
      <template v-if="isShow && complainInfo&&pageType!='C'">
        <causeDetail :detailList="detailList" title="投诉件详情"></causeDetail>
        <template>
          <div class="complain" @click="navToComplain">
            <span>查看投诉件详情</span>
          </div>
        </template>
      </template>

      <!--投诉办结情况-->
      <!-- dev-1.2.0关闭 -->
      <div class="main" v-if="isShow && compDoneInfo&&pageType!='C'">
        <div class="title">投诉24小时办结情况</div>
        <div class="content">
          <div style="height:220px;">
            <pieCharts :pieData="pieList" :pieRatio="pieRatio"></pieCharts>
          </div>
          <div class="tongji line_top mt015">
            <div class="tj-item line_right">
              <div class="name">已办结数量</div>
              <div class="num">
                {{compDoneInfo.doneInNum}}
                <span>起</span>
              </div>
            </div>
            <div class="tj-item line_right">
              <div class="name">未办结数量</div>
              <div class="num">
                {{compDoneInfo.doneOutNum}}
                <span>起</span>
              </div>
            </div>
            <div class="tj-item">
              <div class="name">总数量</div>
              <div class="num">
                {{compDoneInfo.doneNum}}
                <span>起</span>
              </div>
            </div>
          </div>
          <div class="ts-list line_top" @click="toComplaintDetails">
            查看投诉件列表
            <img class="img" src="../../assets/image/t-right.png" />
          </div>
        </div>
      </div>
      <!-- 舆情详情 -->
      <!-- dev-1.2.0关闭 -->
      <template v-if="isShow && opinionInfo&&pageType!='C'">
        <negativeDetail :opinionInfo="opinionInfo"></negativeDetail>
      </template>
      <!-- 企业信息 -->
      <template v-if="isShowInfo">
        <causeDetail :detailList="infoList" title="企业信息"></causeDetail>
      </template>
      <div class="complain" v-if="isShowInfo">
        <span>查看企业详情</span>
      </div>
      <!-- 相关材料 -->
      <template v-if="isShow && assessFile">
        <materialScience :caseList="assessFile" title="相关材料"></materialScience>
      </template>
      <!-- 诚信评价方案 -->
      <!-- dev-1.2.0关闭 -->
      <template v-if="isShow && integPreceptFile&&pageType!='C'">
        <materialScience :caseList="integPreceptFile" title="诚信评价方案"></materialScience>
      </template>
      <!-- 委托合同 -->
      <!-- dev-1.2.0关闭 -->
      <template v-if="isShow && integContraFile&&pageType!='C'">
        <materialScience :caseList="integContraFile" title="委托合同"></materialScience>
      </template>
      <!-- 投入专项经费依据 -->
      <!-- dev-1.2.0关闭 -->
      <template v-if="isShow && integGistFile&&pageType!='C'">
        <materialScience :caseList="integGistFile" title="投入专项经费依据"></materialScience>
      </template>
      <!--诚信评级完成率-->
      <!-- <div class="main">
          <div class="title">诚信评级完成率</div>
          <div class="content">
            <div style=" height:220px;">
              <pieCharts :pieData="pieList2" :pieRatio="pieRatio"></pieCharts>
            </div>
            <div class="pro-mr mt015 line_top  line_bottom">
              <RankChartsRate :rankList="rankList" ></RankChartsRate>
            </div>
            <div class="ts-list" @click="navTo()">
              查看详情评分情况
              <img class="img" src="../../assets/image/t-right.png"/>
            </div>
          </div>
      </div>-->
    </div>
  </div>
</template>
<script>
// import Vue from 'vue';
import causeDeduction from "./components/causeDeduction"; // 扣分原因
import casePublicity from "./components/casePublicity"; // 涉旅案件公示
import materialScience from "./components/materialScience"; // 相关材料
import causeDetail from "./components/causeDetail"; // 扣分详情 企业详情
import pieCharts from "./components/PieCharts"; // 环形进度
import negativeDetail from "./components/negativeDetail"; // 舆情详情
import txtTag from "./components/txt-tag";
import RankChartsRate from "./components/RankChartsRate"; // 进度
import api from "../../service/modules/appraise";
import apimessage from "../../service/modules/message";
import apis from "../../service/modules/index";
import apicomplaint from "../../service/modules/complaint";
import util from "../../utils/common";
import { type } from "os";
// Vue.use(Picker);
export default {
  components: {
    causeDeduction,
    casePublicity,
    materialScience,
    pieCharts,
    negativeDetail,
    txtTag,
    causeDetail,
    RankChartsRate
  },

  data() {
    return {
      // 饼图
      pieList2: [
        { value: 90, name: "完成量" },
        { value: 10, name: "总数量" }
      ],
      rankList: [
        { id: 1, city: "餐饮", mark: "93.23", change: 1, changeRank: 2 },
        { id: 2, city: "住宿", mark: "80.00", change: 2, changeRank: 2 },
        { id: 3, city: "旅行社", mark: "72.30", change: 1, changeRank: 2 },
        { id: 4, city: "租赁车", mark: "60.00", change: 2, changeRank: 2 },
        { id: 5, city: "旅行汽车", mark: "50.00", change: 0, changeRank: 2 }
      ],
      areaType: 1,
      subName: "",
      assessDetail: {},
      subType: "A1",
      row: {},
      isDescStatus: false,
      compDoneInfo: {},
      // 饼图
      pieList: [],
      // 涉旅案件公示列表
      tripCaseList: [],
      // 相关材料列表
      assessTitle: "相关材料",
      assessFile: [],
      integPreceptFile: [],
      integContraFile: [],
      integGistFile: [],
      // 扣分原因
      deductionReason: "",
      complainDetailUrlInfo: {},
      caseDetail: "",
      deducDetail: "",
      // 投诉件详情
      detailList: [],
      // 企业信息
      infoList: [
        {
          name: "企业名称",
          value: "云南洲途国际旅行社有限公司"
        },
        {
          name: "企业地址",
          value: "昆明市官渡区北京路锦华国际酒店14楼"
        },
        {
          name: "政府评价分",
          value: "100分"
        },
        {
          name: "专业评价分",
          value: "100分"
        }
      ],
      opinionInfo: {},
      complainInfo: "",
      urlParams: {},
      urlParams2: {},
      complainQuarter: "",
      stype: "",
      isShow: false,
      pieRatio: "0",
      integrityDoneRate: {},
      quarterName: this.$route.query.quarterName,
      pageType: this.$route.query.pageType
    };
  },

  computed: {
    isShowInfo() {
      if (this.pageType === "C") {
        return false;
      } else if (this.pageType === "E") {
        return false;
      } else if (this.pageType === "D") {
        return false;
      } else if (this.pageType === "B") {
        return false;
      } else if (this.pageType === "A") {
        return false;
      } else if (this.pageType === "F") {
        return false;
      }
      return true;
    }
  },

  watch: {},

  methods: {
    // 考核明细接口
    getSubAssessDetail() {
      api
        .getAssessDetailById({
          id: this.row.id,
          subType: this.subType,
          mainComplainId: this.row.mainComplainId,
          complainId: this.row.complainId
        })
        .then(res => {
          if (res.ret === 0) {
            this.isShow = true;
            this.assessDetail = res.data.assessDetail;
            this.deducDetail = res.data.assessDetail.deducDetail; // 扣分详情
            this.deductionReason = res.data.assessDetail.deductionReason; // 扣分原因
            this.complainDetailUrlInfo =
              res.data.assessDetail.complainDetailUrlInfo;
            this.caseDetail = res.data.assessDetail.caseDetail; // 事故详情
            this.tripCaseList = res.data.assessDetail.tripCaseList; // 涉旅案件列表
            this.assessFile = res.data.assessDetail.assessFile; // 相关材料列表
            this.compDoneInfo = res.data.assessDetail.compDoneInfo; // 投诉办结详情
            this.integrityDoneRate = res.data.assessDetail.integrityDoneRate; // 诚信完成率
            if (res.data.assessDetail.complainInfoFor5) {
              this.complainInfo = res.data.assessDetail.complainInfoFor5;
              this.detailList = [
                {
                  name: "投诉单号",
                  value: this.complainInfo.mainComplainId
                },
                {
                  name: "发生地区",
                  value: this.complainInfo.complainArea
                },
                {
                  name: "响应时间",
                  value: this.complainInfo.respTime
                }
              ];
            }
            if (res.data.assessDetail.complainInfoFor24) {
              this.complainInfo = res.data.assessDetail.complainInfoFor24;
              this.detailList = [
                {
                  name: "投诉单号",
                  value: this.complainInfo.mainComplainId
                },
                {
                  name: "发生地区",
                  value: this.complainInfo.complainArea
                },
                {
                  name: "处理时长",
                  value: this.complainInfo.doneTime
                },
                {
                  name: "一次处理时长",
                  value: this.complainInfo.firstTime
                },
                {
                  name: "二次处理时长",
                  value: this.complainInfo.secondTime
                }
              ];
            }
            this.integPreceptFile = res.data.assessDetail.integPreceptFile; // 诚信评价方案
            this.integContraFile = res.data.assessDetail.integContraFile; // 委托合同
            this.integGistFile = res.data.assessDetail.integGistFile; // 投入专项经费依据
            // this.complainInfo = res.data.assessDetail.complainInfo // 投诉件详情
            this.opinionInfo = res.data.assessDetail.opinionInfo; // 舆情详情
            // this.complainListUrlInfo = res.data.assessDetail.complainListUrlInfo// 查看投诉件详情
            // 投诉件详情
            if (this.compDoneInfo) {
              this.pieList = [
                {
                  value: this.compDoneInfo.doneOutNum,
                  name: "总数量"
                },
                {
                  value: this.compDoneInfo.doneInNum,
                  name: "已办结数量"
                }
              ];
              try {
                this.pieRatio = (
                  (Number(this.compDoneInfo.doneInNum) /
                    Number(this.compDoneInfo.doneNum)) *
                  100
                ).toFixed(2);
              } catch (error) {}
            }
          } else {
            this.$Message.error(res.data.msg);
          }
        });
    },
    toComplaintDetails() {
      // if (this.subType == '5fzwxy') {
      //     this.stype = 'notRespondDetail'
      // } else {
      this.stype = "notFinishedDetail";
      // }
      this.urlParams2 = {
        year: this.complainQuarter.year,
        quarter: this.complainQuarter.quarter,
        type: this.stype,
        cityId: this.complainQuarter.cityId
      };
      sessionStorage.setItem("urlInfo", JSON.stringify(this.urlParams2)); // 参数
      this.$router.push({
        path: "/appraise/complainList" // 跳转到投诉件详情
      });
    },
    // 查投诉详情信息跳转到投诉详细界面
    navToComplain() {
      this.getList();
    },
    // 查询列表
    getList() {
      const data = {
        curPage: 1,
        pageSize: 10,
        type: this.complainDetailUrlInfo.urlParams.type,
        inputParams: this.row.mainComplainId
      };

      apicomplaint.assessToComplain(data).then(res => {
        util.setJsonLocal("item", res.data.list[0]);
        this.$store.commit("complaint/getItemList", res.data.list[0]);
        // this.$router.push(`/complaint/detailListAssess/complaintSheetAssess`)
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/complaint/detailListAssess/complaintSheetAssess`,
            isFullScreen: 0,
            setTitle: "",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      });
    },
    showmoreDesc(e) {
      let el = e.currentTarget;
      el.previousElementSibling.classList[
        !this.isDescStatus ? "add" : "remove"
      ]("hide");
      // el.classList[this.isDescStatus ? 'add' : 'remove']('more-collapse');
      // el.innerHTML = !this.isDescStatus ? '展开' : '收起';
      this.isDescStatus = !this.isDescStatus;
      this.isShowMore = true;
    },
    // 消息单条已读
    onMessageReadOne(isRead, id) {
      if (isRead === "false") {
        apimessage.messageReadOne({ messageId: id }).then(res => {
          localStorage.setItem("messageId", id);
        });
      }
    }
  },

  mounted() {},

  created() {
    let messageId = this.$route.query.messageId || "";
    let isRead = this.$route.query.isRead || "true";
    this.onMessageReadOne(isRead, messageId);

    this.subType = this.$route.query.subType;
    this.subName = this.$route.query.subName;
    this.row = JSON.parse(sessionStorage.getItem("responCont")) || {
      id: this.$route.query.id || "",
      complainId: this.$route.query.complainId || "",
      mainComplainId: this.$route.query.mainComplainId || ""
    };
    this.detailsInfo = JSON.parse(sessionStorage.getItem("detailInfo")) || {
      areaName: this.$route.query.areaName || "",
      areaType: this.$route.query.areaType || ""
    };
    this.getSubAssessDetail();
    this.complainQuarter = JSON.parse(
      sessionStorage.getItem("respondInfo")
    ) || {
      year: this.$route.query.year || "",
      quarter: this.$route.query.quater || "",
      cityId: this.$route.query.cityId || ""
    };
  }
};
</script>
<style scoped lang="less">
@vv: 3.75vw;
.container {
  min-height: 100vh;
  background: rgba(251, 251, 251, 1);
  padding-bottom: 24px;

  .pg-pd12 {
    padding-left: 12px;
    padding-right: 12px;
  }

  .complain {
    position: relative;
    line-height: 46px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    padding: 0 16px;
    margin-top: 24px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  .complain::after {
    content: "";
    position: absolute;
    right: 16px;
    top: 16px;
    width: 12px;
    height: 12px;
    background: url(../../assets/image/t-right.png) no-repeat;
    background-size: 12px 12px;
  }

  .head {
    width: 100%;
    background: #fff;
    padding: 23px 12px 12px 12px;

    .title {
      line-height: 22px;
      display: flex;
      justify-content: space-between;

      .text {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
        padding-right: 50px;
      }

      .branch {
        height: 22px;
        font-size: 22px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: rgba(255, 77, 77, 1);
        line-height: 28px;
      }
      .no-de {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(54, 179, 116, 1);
        line-height: 22px;
      }
    }
    .tag-box {
      width: 120%;
      height: 28px;
      display: flex;
      align-items: center;
      margin-top: 10px;
      transform: scale(0.5);
      transform-origin: left 0;
    }
    .date {
      margin-bottom: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 12px;
    }
  }
  .main {
    margin-top: 24px;

    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }

    .content {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;
      margin-top: 12px;
      .pro-mr {
        margin-top: 24px;
        padding: 12px;
      }
      .tongji {
        display: flex;
        align-items: center;

        .tj-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
          padding: 16px 0;
          text-align: center;

          .name {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }

          .num {
            font-size: 20px;
            font-family: DIN-Bold, DIN;
            font-weight: bold;
            color: rgba(54, 179, 116, 1);
            margin-top: 8px;
            vertical-align: top;
            display: inline-block;
            text-align: center;
            position: relative;

            span {
              font-size: 10px;
              padding-left: 4px;
              font-weight: normal;
              position: absolute;
              float: left;
              display: inline-block;
              font-weight: normal;
              bottom: 2px;
            }
          }
        }
      }
      .mt015 {
        margin-top: -15px;
      }

      .ts-list {
        width: 100%;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(155, 155, 155, 1);
        position: relative;
        vertical-align: top;
        display: inline-block;
        text-align: center;
        line-height: 41px;
        .img {
          position: absolute;
          float: left;
          display: inline-block;
          width: 10px;
          height: 10px;
          top: 50%;
          transform: translateY(-50.5%);
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
